import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Cards from '../Cards/Cards';

import Toni from '../../assets/images/Toni.png';

import './Description.css';

export default function Description() {
    return (
        <Container fluid className="descriptionContainer worldwide" id="cinesunt">
            <Container>
                <Row>
                    <Col xl={7}>
                        <Cards
                            content={
                                <>
                                    <Row className="descriptionCardContainer h-100 justify-content-center align-items-center">
                                        <Col xs={12} md={3} className="text-center">
                                            <img src={Toni} className="descriptionCardImage img-fluid" alt="Toni"/>
                                        </Col>
                                        <Col xs={12} md={9} className="text-center text-md-start">
                                            <p className="descriptionCardText1">Prof. Ing. Crantea Antonio-Cristian</p>
                                            <p className="descriptionCardText2">
                                                Disciplina Informatică &<br/>Tehnologia Informației și a Comunicațiilor
                                            </p>
                                            <p className="descriptionCardText2"><i>Profesor Inginer, Asistent Universitar Voluntar, Programator și Autor</i></p>
                                        </Col>
                                    </Row>
                                </>
                            }
                        />
                    </Col>
                    <Col xl={5} style={{marginTop: "25px"}}>
                        <p className="descriptionTitle">{'<'}Cine sunt eu?{'/>'}</p>
                        <p className="descriptionSubTitle">
                            Numele meu este Crantea Antonio-Cristian și sunt un tânăr ambițios, pasionat de Tehnologie,
                            Informatică și Educație. De-a lungul anilor mi-am dat seama că îmi doresc să devin profesor și să
                            îndrum viitoarele generații de copii să-și găsească pasiunea și drumul în viață, iar astăzi mă aflu
                            aici și încerc să ajut lumea din jur.
                        </p>
                    </Col>
                </Row>
                <Row className="text-center" style={{marginTop: "25px"}}>
                    <div className="heroButtonContainer">
                        <a href="/despre">
                            <Button className="heroButton">Află mai multe</Button>
                        </a>
                    </div>
                </Row>
            </Container>
        </Container>
    )
}